import { Flex, Box } from '@chakra-ui/layout'
import { useDisclosure } from '@chakra-ui/react'
import { Modal } from './Modal'
import { Text } from '@chakra-ui/react'

export function ModalCreateAccredited() {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box
      display="flex"
      borderRadius="md"
      alignItems="center"
      justifyContent="center"
      background="parkoff.orange.300"
      minWidth="10rem"
      height={{base: "2.5rem", tablet: "2rem" }}
      width={{base: "100%", tablet: "auto" }}
    >
      <Modal isOpen={isOpen} onClose={onClose} />
      <Flex
        display="flex"
        alignItems="center"
        justifyContent="center"
        as="button"
        width="100%"
        height="100%"
        onClick={() => onOpen()}
      >
        <Text
          fontSize="0.75rem"
          fontWeight="700"
          textColor="gray.800"
        >
          + Adicionar novo
        </Text>
      </Flex>
    </Box>
  )
}
